import { render, staticRenderFns } from "./ForumLeftSideBar.vue?vue&type=template&id=4730945a&"
import script from "./ForumLeftSideBar.vue?vue&type=script&lang=js&"
export * from "./ForumLeftSideBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports